import { render, staticRenderFns } from "./Sliders.vue?vue&type=template&id=075d0a29"
import script from "./Sliders.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sliders.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports